import apiClient from "../helpers/apiClient";

export const getMembers = async (params:any={}) => {
    const response = await apiClient.get('/admins/', { params: params });
    return response.data;
};

export const getRoles = async () => {
    const response = await apiClient.get('/roles/');
    return response.data.results;
};

export const getMember = async (id:any) => {
    const response = await apiClient.get('/admins/'+id+'/');
    return response.data;
};

export const createMember = async (values:any) => {
    const response = await apiClient.post(
        '/admins/',
        values);
    return response.data;
};

export const updateMember = async (values:any) => {
    const response = await apiClient.patch(
        '/admins/'+values.id+'/',
        values);
    return response.data;
};

export const updateProfilePicture = async (formData:FormData, id:any) => {
    const response = await apiClient.patch(
        '/admins/'+id+'/upload-photo/',
        formData);
    return response.data;
};


export const getAdminCommunityPending = async (userId: number | string, section: 'forum' | 'circle', page: number) => {
    const response = await apiClient.get(`/community/admin/users/${userId}/pending-approval/`, { params: { post_type: section, offset: page*5 } });
    return response.data;
};

export const getAdminCommunityStats = async (userId: number | string, section: 'forum' | 'circle') => {
    const response = await apiClient.get(`/community/admin/users/${userId}/stats/`, { params: { post_type: section } });
    return response.data;
};

export const getAdminCommunityMastermind = async (userId: number | string, page: number) => {
    const response = await apiClient.get(`/community/admin/users/${userId}/mastermind-circles/`, { params: { offset: page*5 } });
    return response.data;
};

export const getAdminCommunityOpen = async (userId: number | string, page: number) => {
    const response = await apiClient.get(`/community/admin/users/${userId}/open-forums/`, { params: { offset: page*5 } });
    return response.data;
};

export const getMemberGuideList = async (search?: string) => {
    let params: any = {};
    if(search)
        params.search = search;
    const response = await apiClient.get(`/users/admin/member-guide/`, { params } );
    return response.data;
}

export const getMemberGuide = async (userId: number) => {
    const response = await apiClient.get(`/users/admin/member-guide/${userId}/`);
    return response.data;
}

export const updateMemberGuide = async (userId: number, member_guide_id: number | null) => {
    const response = await apiClient.put(`/users/admin/member-guide/${userId}/`, { member_guide_id });
    return response.data;
}

export const getMemberTierList = async () => {
    const response = await apiClient.get(`/members/admin/member-tier/`);
    return response.data;
}

export const getMemberTier = async (userId: number) => {
    const response = await apiClient.get(`/members/admin/member-tier/${userId}/`);
    return response.data;
}

export const updateMemberTier = async (userId: number, member_tier_id: number | null) => {
    const response = await apiClient.put(`/members/admin/member-tier/${userId}/`, { member_tier_id });
    return response.data;
}

export const getMemberStatus = async (userId: number) => {
    const response = await apiClient.get(`/users/admin/status/${userId}/`);
    return response.data;
}

export const getMemberBanList = async (userId: number) => {
    const response = await apiClient.get(`/users/admin/${userId}/bans/`);
    return response.data;
}

export const deleteMemberBan = async (userId: number) => {
    const response = await apiClient.delete(`/users/admin/bans/${userId}/`);
    return response.data;
}

export const permissionModules = async () => {
    const response = await apiClient.get('/users/permissions/modules/',{params: { limit: 20, offset: 0 }});
    return response.data;
};

export const permissionByRole = async (roleId: number) => {
    const response = await apiClient.get(`/users/roles/${roleId}/permissions/`,{params: { limit: 20, offset: 0 }});
    return response.data;
};

export const getMyPermissionModules = async (id:number,roleId:number) => {
    const response = await apiClient.get(`/users/${id}/permissions/`,{params:{role_id:roleId}});
    return response.data;
};

export const updateMyPermission = async (id:number,data:any[]) => {
    const response = await apiClient.put(`/users/${id}/permissions/`,data);
    return response.data;
};

export const getConfigNotificationCatalog = async () => {
    const response = await apiClient.get(`/users/notifications/catalog/`);
    return response.data.results ?? [];
}

export const getMemberConfigNotification = async (params: any) => {
    const response = await apiClient.get(`/users/notifications/config/`,{ params: params });
    return response.data;
}

export const updateMemberConfigNotification = async (params: any) => {
    const response = await apiClient.post(`/users/notifications/config/`,params);
    return response;
}

export const resendEmailActivationAccount = async (params: any) => {
    const response = await apiClient.post(`/users/notifications/send-activation/`,params);
    return response.data;
}

export const getMembershipPurchaseData = async () => {
    const response = await apiClient.get('/members/admin/membership/purchase-data/');
    return response.data;
}

export const createMembership = async (values: any) => {
    const response = await apiClient.post('/members/admin/membership/create/', values);
    return response.data;
}